import React, { useState, useEffect, useRef } from 'react';
import { push } from 'connected-react-router';
import { connect } from 'react-redux';

interface IProps {
  goTo: (path: string) => void;
}

const Instructions: React.SFC<IProps> = ({
  goTo,
}) => {
  const intervalRef = useRef<any|undefined>(undefined);
  const [timeLeft, setTimeLeft] = useState(10);

  useEffect(() => {
    if (timeLeft <= 0) {
      clearInterval(intervalRef.current);
      goTo('/auth');
      return;
    }
    const timerId = setInterval(
      () => {
        setTimeLeft(current => current - 1)
      },
      1000
    );
    intervalRef.current = timerId;

    return () => {
      clearInterval(timerId);
    };
  }, [timeLeft]);

  return (
    <div className="container">
      <div className="entry wdth text-center m-auto">
        <span className="text-center">
          <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M17.9683 35.1289C18.1293 35.362 18.3938 35.4946 18.6731 35.4946C18.7311 35.4946 18.7905 35.4732 18.8494 35.4615C18.8921 35.4684 18.9336 35.4894 18.9768 35.4894C19.2277 35.4894 19.4717 35.3807 19.6427 35.1922L38.6319 16.2C38.9744 15.8579 38.9744 15.3028 38.6319 14.9602C38.2897 14.6181 37.7347 14.6181 37.3925 14.9602L18.8371 33.5182L12.5793 27.2617C12.2372 26.9191 11.6821 26.9191 11.3399 27.2617C10.9974 27.6038 10.9974 28.1589 11.3399 28.5015L17.9683 35.1289Z" fill="#FFD800" />
            <path d="M25 0C11.215 0 0 11.215 0 25C0 38.785 11.215 50 25 50C38.785 50 50 38.785 50 25C50 11.215 38.785 0 25 0ZM25 48.3333C12.1342 48.3333 1.66667 37.8658 1.66667 25C1.66667 12.1342 12.1342 1.66667 25 1.66667C37.8658 1.66667 48.3333 12.1342 48.3333 25C48.3333 37.8658 37.8658 48.3333 25 48.3333Z" fill="#FFD800" />
          </svg>
        </span>
        <h3 className="text-center mt-3 mt-md-4 mb-md-1 mb-0">Инструкции по восстановлению пароля отправлены на ваш e-mail</h3>
        <span className="success-span">
          Через {timeLeft} секунд вы
          <span className="d-block d-md-none" /> вернетесь к экрану
          <span className="d-block d-md-none">
          </span> входа
        </span>
      </div>
    </div>
  );
};

const actions = {
  goTo: push,
};

export default connect(null, actions)(Instructions);
